import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const defaultState = {
  isFetching: false,
  isLoaded: false,
  data: []
};

const collectionsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCH_COLLECTIONS_REQUEST:
      return { ...state, isFetching: action.loading, isLoaded: false };
    case types.FETCH_COLLECTIONS_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: action.loading,
        isLoaded: true
      };
    case USER_SIGNED_OUT:
      return defaultState;
    default:
      return state;
  }
};

export default collectionsReducer;
